/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubCategory } from '../models/SubCategory';
import type { SubCategoryCreate } from '../models/SubCategoryCreate';
import type { SubCategoryPatch } from '../models/SubCategoryPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubCategoryService {
    /**
     * Get Sub Categories
     * Get all sub categories.
     * @param searchTerm
     * @param offset
     * @param limit
     * @returns SubCategory Successful Response
     * @throws ApiError
     */
    public static getSubCategories(
        searchTerm?: (string | null),
        offset?: number,
        limit: number = 100,
    ): CancelablePromise<Array<SubCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sub_category/',
            query: {
                'search_term': searchTerm,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Sub Category
     * Create a new sub category.
     * @param requestBody
     * @returns SubCategory Successful Response
     * @throws ApiError
     */
    public static createSubCategory(
        requestBody: SubCategoryCreate,
    ): CancelablePromise<SubCategory> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sub_category/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Sub Category
     * @param name
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSubCategoryByName(
        name: string,
    ): CancelablePromise<(SubCategory | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sub_category/name/{name}',
            path: {
                'name': name,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Sub Category
     * Update an existing sub category.
     * @param subCategoryId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static patchSubCategory(
        subCategoryId: number,
        requestBody: SubCategoryPatch,
    ): CancelablePromise<(SubCategory | null)> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sub_category/{sub_category_id}',
            path: {
                'sub_category_id': subCategoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set League Order
     * @param requestBody
     * @returns SubCategory Successful Response
     * @throws ApiError
     */
    public static setLeagueOrderSubCategorySetOrderPost(
        requestBody: Array<number>,
    ): CancelablePromise<Array<SubCategory>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sub_category/set_order',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
